import {
  makeStyles
} from "@material-ui/core";
import withLayout from "components/HoC/withLayout";
import PersonalSignature from "components/user/PersonalSignature";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(4),
  },
}));

function PersonalSignaturePage() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <PersonalSignature />
    </div>
  )
}

export default withLayout(PersonalSignaturePage)